import { supabase } from './client';

export async function getActiveBroadcast(): Promise<{ activeBroadcastId: string | null } | null> {
  const { data, error } = await supabase
    .from('broadcast_settings')
    .select('active_broadcast_id')
    .order('updated_at', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  return data ? { activeBroadcastId: data.active_broadcast_id } : null;
}

export async function getBroadcastSettings(): Promise<{ activeBroadcastId: string | null; defaultTournamentId: string | null } | null> {
  const { data, error } = await supabase
    .from('broadcast_settings')
    .select('active_broadcast_id, default_tournament_id')
    .order('updated_at', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  if (!data) return null;
  return {
    activeBroadcastId: data.active_broadcast_id ?? null,
    defaultTournamentId: data.default_tournament_id ?? null,
  };
}

export async function setDefaultTournament(tournamentId: string | null): Promise<void> {
  const { error } = await supabase
    .from('broadcast_settings')
    .update({ default_tournament_id: tournamentId })
    .neq('id', '00000000-0000-0000-0000-000000000000');

  if (error) throw error;
}

export async function setActiveBroadcast(broadcastId: string | null, adminId?: string): Promise<void> {
  const { error } = await supabase
    .from('broadcast_settings')
    .update({
      active_broadcast_id: broadcastId,
      updated_by: adminId || null,
    })
    .neq('id', '00000000-0000-0000-0000-000000000000');

  if (error) throw error;
}

export async function getAllBroadcastIds(): Promise<{ broadcastId: string; matchNumber: number; teamA: string; teamB: string; status: string; tournamentId: string | null }[]> {
  const { data, error } = await supabase
    .from('matches')
    .select(`
      broadcast_id,
      match_number,
      status,
      tournament_id,
      team_a:teams!matches_team_a_id_fkey (name),
      team_b:teams!matches_team_b_id_fkey (name)
    `)
    .neq('status', 'discarded')
    .order('match_number', { ascending: false });

  if (error) throw error;

  return (data || []).map((m: any) => ({
    broadcastId: m.broadcast_id,
    matchNumber: m.match_number,
    teamA: m.team_a?.name || 'Unknown',
    teamB: m.team_b?.name || 'Unknown',
    status: m.status,
    tournamentId: m.tournament_id ?? null,
  }));
}
